import React, { useContext, useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import AppContext from '../../../App/AppContext';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    TextBox,
    PasswordBox,
    SecondaryButton,
    PrimaryCheckbox,
    DialogContents,
    DialogTitles,
    DialogsActions,
    Dialogs,
    SecondaryCheckbox,
    Multiselect,
    MultiselectWithoutCheckbox,
    YesNoButton,
    SelectBox
} from '../../../Core/FormInput';
import { getWorkflows } from '../../../Core/Service/workflow-service';
import { getBranches } from '../../../Core/Service/branches-service';
import { getCustomer } from '../../../Core/Service/customer-services';
import { Adduser, UpdateUser, getUser, getScreenDropdown, getCustomerScreenDropdown } from '../../../Core/Service/admin-service';
import CloseIcon from '@material-ui/icons/Close';
import { Checkbox, IconButton } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import UserModules from './userModules';
import { AppStorage } from '../../../Core/Service/storage-service';
import { filter } from 'lodash';

const AddUserModal = (props) => {
    const { hideModal, showToast, portalSettings, userRoles } = useContext(AppContext);
    const [masterData, setMasterData] = useState({
        workflows: [],
        filteredWorkflows: []
    });

    const [brancheData, setbrancheData] = useState({
        branches: []
    });

    const [processData, setprocessData] = useState({
        processes: []
    });

    const [moduleData, setmoduleData] = useState({
        modules: [
            { name: 'eWIP', id: 'eWIP' },
            { name: 'Reporting', id: 'Reporting' },
            { name: 'Communicator', id: 'Communicator' }
        ]
    });

    const [franchiseData, setFranchisesData] = useState({
        franchises: []
    });

    const [customerData, setcustomerData] = useState({
        customers: []
    });

    const [custmerGroup, setCustomerGroup] = useState([]);

    const [appraisalVehicleOption, setAppraisalVehicleOption] = useState([]);

    const [maDashboardData, setmaDashboardData] = useState({
        maDashboard: []
    });
    const [selectedData, setSelectedData] = useState({
        customers: [],
        workflows: [],
        branches: [],
        processes: [],
        modules: [],
        franchises: [],
        appraisalVehicles: [],
        maDashboard: []
    });
    const [state, setState] = useState({
        userType: '',
        email: '',
        name: '',
        phone: '',
        password: '',
        confirm: '',
        enableChange: false,
        allbranch: false,
        allprocess: false,
        allcust: false,
        allworkflow: false,
        allMaDashboard: false,
        isActive: true,
        isLocked: false,
        customer: [],
        workflow: [],
        branches: [],
        processes: [],
        appraiserRoleList: [],
        appraisalVehicle: [],
        maDashboard: [],
        doc_id: '',
        canOverrideMandatorySteps: false,
        canAssignJobsToAuditor: false,
        canReturnJobsFromLastWorkflow: false,
        canDeleteDocuments: false,
        canResetPassword: false,
        canAssignTechnician: false,
        canAssignJobPriority: false,
        franchises: [],
        isAgedMeasure: false,
        isDOC: false,
        isKPIs: false,
        isParts: false,
        isSales: false,
        isService: false,
        isWorkShop: false,
        eWIPAllowed: false,
        specialEquipmentAllowed: false,
        canAmendToDoList: false,
        canAmendTechWriteUp: false,
        canAmendJobNotes: false,
        autoLoadDocuments: false,
        canAuthorisedHandoverSheet: false,
        canActionedHandoverSheet: false,
        canAccessLockScreen: false,
        canUploadVehicleDocs: false,
        canDeleteVehicleDocs: false,
        canSignedOffHandoverSheet: false,
        canSignBrakeTests: false,
        canAccessSalesWIP: false,
        canAccessDocumentReprocessScreen: false,

        canHideDocumentCreation: false,
        canSetCustomerRating: false,
        eReportingAllowed: false,
        eCommunicatorAllowed: false,
        eInvoiceAllowed: false,
        canAccessAppraisalPortal: false,
        isBudgetDashboard: false,
        userCustomerGroupID: null,
        sendEmailFromOwnEmail: false,
        canAccessBudget: false,
        defaultInternalDashboard: null,
        twoFactorEnabled: false,
        tempTwoFactorEnabled: false,
        canSignOffTechWriteup: false,
        canDeleteTechWriteup: false,
        canAccessSalesPerformance: false,
        appraisalRoleID: '',
        canAccessNominalMapping: false,
        canAccessNominalTransactions: false,
        canAccessNominalAccounts: false,
        myJobTxtColor: '',
        myJobBgColor: '',
        canResetJobSignoffSignature: false
    });

    const user = props.users;

    useEffect(() => {
        if (user) {
            const selectedfranchises = franchiseData.franchises.filter((w) => state.franchises.indexOf(w.id) > -1);
            const selectedCust = customerData.customers.filter((w) => state.customer.indexOf(w.id) > -1);
            const selectedWorkflows = masterData.workflows.filter((w) => state.workflow.indexOf(w.id) > -1);
            const selectedBranches = brancheData.branches.filter((w) => state.branches.indexOf(w.id) > -1);
            const filteredProcesses = processData.processes ? processData.processes.filter(p => {
                if (!processData.branchProcessMapping || processData.branchProcessMapping.length === 0) return true;
                if (state.branches.length === 0 && (state.userType === 'internal' || state.userType === 'technician')) return false;
                if (state.branches.length === 0) return true;
                return processData.branchProcessMapping.some(m => state.branches.includes(m.branchId) && m.processId === p.id);
            }) : [];
            const selectedProcesses = filteredProcesses.filter((w) => state.processes.indexOf(w.id) > -1);
            const selectedAppraisalVehicle = appraisalVehicleOption.filter((w) => state.appraisalVehicle.indexOf(w.id) > -1);
            const selectedMaDashboard = maDashboardData.maDashboard.filter((w) => state.maDashboard.indexOf(w.id) > -1);
            setSelectedData((st) => ({
                ...st,
                customers: selectedCust,
                workflows: selectedWorkflows,
                branches: selectedBranches,
                processes: selectedProcesses,
                franchises: selectedfranchises,
                appraisalVehicles: selectedAppraisalVehicle,
                maDashboard: selectedMaDashboard
            }));

            if (customerData.customers.length > 0 && customerData.customers === selectedCust.length) {
                setState((st) => ({ ...st, allcust: true }));
            }

            if (masterData.workflows.length > 0 && masterData.workflows.length === selectedWorkflows.length) {
                setState((st) => ({ ...st, allworkflow: true }));
            }

            if (brancheData.branches.length > 0 && brancheData.branches.length === selectedBranches.length) {
                setState((st) => ({ ...st, allbranch: true }));
            }


            if (filteredProcesses.length > 0 && filteredProcesses.length === selectedProcesses.length) {
                setState((st) => ({ ...st, allprocess: true }));
            }
            if (maDashboardData.maDashboard.length > 0 && maDashboardData.maDashboard.length === selectedMaDashboard.length) {
                setState((st) => ({ ...st, allMaDashboard: true }));
            }
        }
    }, [
        state.franchises,
        state.branches,
        state.processes,
        state.workflow,
        state.customer,
        masterData.workflows,
        brancheData.branches,
        processData.processes,
        customerData.customers,
        franchiseData.franchises,
        state.appraisalVehicle,
        state.maDashboard,
        appraisalVehicleOption,
        maDashboardData.maDashboard
    ]);

    function updateDashboardList(portalSettings) {
        const updatedList = [];
        if (portalSettings.portalSettingeWIPEnabled) {
            updatedList.push({ id: 1, name: 'eWIP' });
        }
        if (portalSettings.portalSettingReportingEnabled) {
            updatedList.push({ id: 2, name: 'Reporting' });
        }
        if (portalSettings.portalSettingInvoiceEnabled) {
            updatedList.push({ id: 3, name: 'Invoices' });
        }
        if (portalSettings.portalSettingCommunicatorEnabled) {
            updatedList.push({ id: 4, name: 'Communicator' });
        }
        setState((st) => ({ ...st, DashboardList: updatedList }));
    }

    useEffect(async () => {
        let resCust = await getCustomerScreenDropdown();

        if (resCust.success) {
            const customers = resCust?.data?.customers;

            setcustomerData((st) => ({ ...st, customers }));
        }
        let respo = await getScreenDropdown();
        if (respo.success) {
            const workflows = respo?.data?.workflows;
            // .filter((w) => !w.isTechnicianWorkflow)
            // .map((w) => ({
            //     ...w
            // }));
            const customerGroup = respo?.data?.customerGroups;
            const branches = respo?.data?.branches;
            const processes = respo?.data?.processes;
            const updatedAppraiserRoles = respo?.data?.appraiserRoles.filter((role) => role.name !== 'Customer');
            const appraisalVehicleOption = respo?.data?.appraiserVehicles || [];
            const maDashboard = respo?.data?.maDashboard || [];
            setMasterData((st) => ({ ...st, workflows }));
            setbrancheData((st) => ({ ...st, branches }));
            setprocessData((st) => ({ ...st, processes, branchProcessMapping: respo?.data?.branchProcessMapping || [] }));
            setFranchisesData((st) => ({ ...st, franchises: respo?.data?.franchiseCode }));
            setCustomerGroup(customerGroup);
            setState((st) => ({ ...st, appraiserRoleList: updatedAppraiserRoles }));
            setAppraisalVehicleOption(appraisalVehicleOption);
            setmaDashboardData((st) => ({ ...st, maDashboard }));
        }
        updateDashboardList(portalSettings);
        if (user) {
            let result = await getUser(user.id);
            const updatedUser = result.data;
            if (result.success) {
                setState((st) => ({
                    ...st,
                    franchises: updatedUser.franchisesCode,
                    doc_id: props.copiedUser ? null : updatedUser.id,
                    name: props.copiedUser ? '' : updatedUser.displayName,
                    phone: props.copiedUser ? '' : updatedUser.phoneNo,
                    email: props.copiedUser ? '' : updatedUser.email,
                    userType: updatedUser.userRole,
                    isActive: updatedUser.isActive,
                    isLocked: updatedUser.isLocked,
                    enableChange: true,
                    workflow: updatedUser.workflowIds,
                    branches: updatedUser.branchIds,
                    processes: updatedUser.processIds,
                    customer: updatedUser.customerIds,
                    appraisalVehicle: updatedUser.appraisalVehicleIDs || [],
                    maDashboard: updatedUser.maDashboardIDs || [],
                    canOverrideMandatorySteps: updatedUser.canOverrideMandatorySteps,
                    canAssignJobsToAuditor: updatedUser.canAssignJobsToAuditor,
                    canReturnJobsFromLastWorkflow: updatedUser.canReturnJobsFromLastWorkflow,
                    canDeleteDocuments: updatedUser.canDeleteDocuments,
                    canResetPassword: updatedUser.canResetPassword,
                    canAssignJobPriority: updatedUser.canAssignJobPriority,
                    canAssignTechnician: updatedUser.canAssignTechnician,
                    canSetCustomerRating: updatedUser.canSetCustomerRating,
                    isAgedMeasure: updatedUser.isAgedMeasure,
                    isDOC: updatedUser.isDOC,
                    isKPIs: updatedUser.isKPIs,
                    isParts: updatedUser.isParts,
                    isSales: updatedUser.isSales,
                    isService: updatedUser.isService,
                    isWorkShop: updatedUser.isWorkShop,
                    eWIPAllowed: updatedUser.eWIPAllowed,
                    specialEquipmentAllowed: updatedUser.specialEquipmentAllowed,
                    canAmendToDoList: updatedUser.canAmendToDoList,
                    canAmendTechWriteUp: updatedUser.canAmendTechWriteUp,
                    canAmendJobNotes: updatedUser.canAmendJobNotes,
                    autoLoadDocuments: updatedUser.autoLoadDocuments,
                    canAuthorisedHandoverSheet: updatedUser.canAuthorisedHandoverSheet,
                    canActionedHandoverSheet: updatedUser.canActionedHandoverSheet,
                    canAccessLockScreen: updatedUser.canAccessLockScreen,
                    canHideDocumentCreation: updatedUser.canHideDocumentCreation,
                    canDeleteVehicleDocs: updatedUser.canDeleteVehicleDocs,
                    canSignedOffHandoverSheet: updatedUser.canSignedOffHandoverSheet,
                    myJobTxtColor: updatedUser.myJobTxtColor,
                    myJobBgColor: updatedUser.myJobBgColor,
                    canSignBrakeTests: updatedUser.canSignBrakeTests,
                    canAccessSalesWIP: updatedUser.canAccessSalesWIP,
                    canAccessDocumentReprocessScreen: updatedUser.canAccessDocumentReprocessScreen,

                    eReportingAllowed: updatedUser.eReportingAllowed,
                    eCommunicatorAllowed: updatedUser.eCommunicatorAllowed,
                    eInvoiceAllowed: updatedUser.eInvoiceAllowed,
                    canAccessAppraisalPortal: updatedUser.canAccessAppraisalPortal,
                    isBudgetDashboard: updatedUser.isBudgetDashboard,
                    userCustomerGroupID: updatedUser.userCustomerGroupID,
                    sendEmailFromOwnEmail: updatedUser.sendEmailFromOwnEmail,
                    canAccessBudget: updatedUser.canAccessBudget,
                    defaultInternalDashboard: updatedUser.defaultInternalDashboard,
                    twoFactorEnabled: updatedUser.twoFactorEnabled,
                    canSignOffTechWriteup: updatedUser.canSignOffTechWriteup,
                    canDeleteTechWriteup: updatedUser.canDeleteTechWriteup,
                    canAccessSalesPerformance: updatedUser.canAccessSalesPerformance,
                    appraisalRoleID: updatedUser.appraisalRoleID,
                    canAccessNominalMapping: updatedUser.canAccessNominalMapping,
                    canAccessNominalTransactions: updatedUser.canAccessNominalTransactions,
                    canAccessNominalAccounts: updatedUser.canAccessNominalAccounts,
                    canUploadVehicleDocs: updatedUser.canUploadVehicleDocs,
                    canResetJobSignoffSignature: updatedUser.canResetJobSignoffSignature
                }));
            }
        }
    }, []);

    const handleClose = () => {
        props.onFormSubmit(false);
        hideModal();
    };

    const handleSubmit = async (e) => {
        let commonData = {
            id: state.doc_id || null,
            displayName: state.name,
            email: state.email,
            phone: state.phone,
            isLocked: state.isLocked,
            isActive: state.isActive,
            twoFactorEnabled: state.tempTwoFactorEnabled ? false : state.twoFactorEnabled,
            userRole: state.userType,
            sendEmailFromOwnEmail: state.sendEmailFromOwnEmail,
            processIds: state.processes
        };

        let nicolReportDefaultFlag = {
            canAccessBranchOverview: false,
            canAccessSalesProfitAndLoss: false,
            canAccessAfterSalesProfitAndLoss: false,
            canAccessProfitAndLossDetail: false,
            canAccessUsedStockValuation: false,
            canAccessUsedVehicleStock: false,
            canAccessAgedVehicleStock: false,
            canAccessOveragePriorityList: false,
            canAccessSalesReporting: false
        };

        let customData = {
            admin: {
                ...commonData,
                branchIds: [],
                customerIds: [],
                workflowIds: [],
                canOverrideMandatorySteps: false,
                canAssignJobsToAuditor: false,
                canReturnJobsFromLastWorkflow: false,
                canResetPassword: false,
                canAssignJobPriority: false,
                canAssignTechnician: false,
                canDeleteDocuments: false,
                canSetCustomerRating: false,
                specialEquipmentAllowed: false,
                canAmendToDoList: false,
                canAmendTechWriteUp: false,
                canAuthorisedHandoverSheet: false,
                canActionedHandoverSheet: false,
                canAccessLockScreen: false,
                canUploadVehicleDocs: false,
                canHideDocumentCreation: false,
                canDeleteVehicleDocs: false,
                canSignedOffHandoverSheet: false,
                myJobTxtColor: '',
                myJobBgColor: '',
                canSignBrakeTests: false,
                canAccessSalesWIP: false,
                canAccessDocumentReprocessScreen: false,

                canAmendJobNotes: false,
                autoLoadDocuments: false,
                canSignOffTechWriteup: false,
                canDeleteTechWriteup: false,
                isAgedMeasure: false,
                isDOC: false,
                isKPIs: false,
                isParts: false,
                isSales: false,
                isService: false,
                isWorkShop: false,
                franchisesCode: [],
                eWIPAllowed: false,
                eReportingAllowed: false,
                eCommunicatorAllowed: false,
                eInvoiceAllowed: false,
                isBudgetDashboard: false, //state.isBudgetDashboard,
                userCustomerGroupID: null,
                canAccessBudget: false,
                canAccessSalesPerformance: false,
                canAccessAppraisalPortal: state.canAccessAppraisalPortal,
                appraisalVehicleIDs: [],
                maDashboardIDs: [],
                canAccessNominalMapping: false,
                canAccessNominalTransactions: false,
                canAccessNominalAccounts: false,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            },
            auditor: {
                ...commonData,
                branchIds: [],
                branchIds: state.branches,
                customerIds: [],
                workflowIds: state.workflow,
                canOverrideMandatorySteps: state.canOverrideMandatorySteps,
                canAssignJobsToAuditor: state.canAssignJobsToAuditor,
                canReturnJobsFromLastWorkflow: state.canReturnJobsFromLastWorkflow,
                canResetPassword: state.canResetPassword,
                canAssignJobPriority: state.canAssignJobPriority,
                canAssignTechnician: state.canAssignTechnician,
                canDeleteDocuments: state.canDeleteDocuments,
                canSetCustomerRating: state.canSetCustomerRating,
                isAgedMeasure: state.isAgedMeasure,
                isDOC: state.isDOC,
                isKPIs: state.isKPIs,
                isParts: state.isParts,
                isSales: state.isSales,
                isService: state.isService,
                isWorkShop: state.isWorkShop,
                franchisesCode: state.franchises,
                eWIPAllowed: state.eWIPAllowed,
                specialEquipmentAllowed: state.specialEquipmentAllowed,
                canAmendToDoList: state.canAmendToDoList,
                canAmendTechWriteUp: state.canAmendTechWriteUp,
                canAuthorisedHandoverSheet: state.canAuthorisedHandoverSheet,
                canActionedHandoverSheet: state.canActionedHandoverSheet,
                canAccessLockScreen: state.canAccessLockScreen,
                canUploadVehicleDocs: state.canUploadVehicleDocs,
                canHideDocumentCreation: state.canHideDocumentCreation,
                canDeleteVehicleDocs: state.canDeleteVehicleDocs,
                canSignedOffHandoverSheet: state.canSignedOffHandoverSheet,
                myJobTxtColor: state.myJobTxtColor,
                myJobBgColor: state.myJobBgColor,
                canSignBrakeTests: state.canSignBrakeTests,
                canAccessSalesWIP: state.canAccessSalesWIP,
                canAccessDocumentReprocessScreen: false,

                canAmendJobNotes: state.canAmendJobNotes,
                autoLoadDocuments: state.autoLoadDocuments,
                eReportingAllowed: state.eReportingAllowed,
                eCommunicatorAllowed: state.eCommunicatorAllowed,
                eInvoiceAllowed: state.eInvoiceAllowed,
                isBudgetDashboard: false, //state.isBudgetDashboard,
                userCustomerGroupID: state.userCustomerGroupID,
                canAccessBudget: state.canAccessBudget,
                defaultInternalDashboard: state.defaultInternalDashboard,
                canSignOffTechWriteup: state.canSignOffTechWriteup,
                canDeleteTechWriteup: state.canDeleteTechWriteup,
                canAccessSalesPerformance: state.canAccessSalesPerformance,
                canAccessAppraisalPortal: state.canAccessAppraisalPortal,
                appraisalRoleID: state.appraisalRoleID,
                appraisalVehicleIDs: state.appraisalVehicle,
                maDashboardIDs: state.maDashboard,
                canAccessNominalMapping: state.canAccessNominalMapping,
                canAccessNominalTransactions: state.canAccessNominalTransactions,
                canAccessNominalAccounts: state.canAccessNominalAccounts,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            },
            customer: {
                ...commonData,
                branchIds: [],
                customerIds: state.customer,
                workflowIds: state.workflow,
                canOverrideMandatorySteps: state.canOverrideMandatorySteps,
                canAssignJobsToAuditor: state.canAssignJobsToAuditor,
                canReturnJobsFromLastWorkflow: state.canReturnJobsFromLastWorkflow,
                canResetPassword: state.canResetPassword,
                canAssignJobPriority: false,
                canAssignTechnician: false,
                canSetCustomerRating: false,
                specialEquipmentAllowed: false,
                canAmendToDoList: false,
                canAmendTechWriteUp: false,
                canAuthorisedHandoverSheet: state.canAuthorisedHandoverSheet,
                canActionedHandoverSheet: state.canActionedHandoverSheet,
                canAccessLockScreen: state.canAccessLockScreen,
                canUploadVehicleDocs: state.canUploadVehicleDocs,
                canHideDocumentCreation: state.canHideDocumentCreation,
                canDeleteVehicleDocs: state.canDeleteVehicleDocs,
                canSignedOffHandoverSheet: state.canSignedOffHandoverSheet,
                myJobTxtColor: state.myJobTxtColor,
                myJobBgColor: state.myJobBgColor,
                canSignBrakeTests: state.canSignBrakeTests,
                canAccessSalesWIP: state.canAccessSalesWIP,
                canAccessDocumentReprocessScreen: false,

                canAmendJobNotes: false,
                autoLoadDocuments: state.autoLoadDocuments,
                canDeleteDocuments: state.canDeleteDocuments,
                isAgedMeasure: false,
                isDOC: false,
                isKPIs: false,
                isParts: false,
                isSales: false,
                isService: false,
                isWorkShop: false,
                franchisesCode: state.franchises,
                eWIPAllowed: state.eWIPAllowed,
                eReportingAllowed: false,
                eCommunicatorAllowed: state.eCommunicatorAllowed,
                eInvoiceAllowed: state.eInvoiceAllowed,
                isBudgetDashboard: false, //state.isBudgetDashboard,
                userCustomerGroupID: state.userCustomerGroupID,
                canAccessBudget: false,
                defaultInternalDashboard: state.defaultInternalDashboard,
                canSignOffTechWriteup: false,
                canDeleteTechWriteup: false,
                canAccessSalesPerformance: false,
                canAccessAppraisalPortal: state.canAccessAppraisalPortal,
                appraisalRoleID: portalSettings.portalSettingsAppraisalEnabled ? 'fa3db6d0-9335-4d47-8849-524f81b2e4df' : '',
                appraisalVehicleIDs: state.appraisalVehicle,
                maDashboardIDs: state.maDashboard,
                canAccessNominalMapping: false,
                canAccessNominalTransactions: false,
                canAccessNominalAccounts: false,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            },
            internal: {
                ...commonData,
                branchIds: state.branches,
                customerIds: [],
                workflowIds: state.workflow,
                canOverrideMandatorySteps: state.canOverrideMandatorySteps,
                canAssignJobsToAuditor: state.canAssignJobsToAuditor,
                canReturnJobsFromLastWorkflow: state.canReturnJobsFromLastWorkflow,
                canResetPassword: state.canResetPassword,
                canAssignJobPriority: state.canAssignJobPriority,
                canAssignTechnician: state.canAssignTechnician,
                canDeleteDocuments: state.canDeleteDocuments,
                canSetCustomerRating: state.canSetCustomerRating,
                isAgedMeasure: state.isAgedMeasure,
                isDOC: state.isDOC,
                isKPIs: state.isKPIs,
                isParts: state.isParts,
                isSales: state.isSales,
                isService: state.isService,
                isWorkShop: state.isWorkShop,
                franchisesCode: state.franchises,
                eWIPAllowed: state.eWIPAllowed,
                specialEquipmentAllowed: state.specialEquipmentAllowed,
                canAmendToDoList: state.canAmendToDoList,
                canAmendTechWriteUp: state.canAmendTechWriteUp,
                canAuthorisedHandoverSheet: state.canAuthorisedHandoverSheet,
                canActionedHandoverSheet: state.canActionedHandoverSheet,
                canAccessLockScreen: state.canAccessLockScreen,
                canUploadVehicleDocs: state.canUploadVehicleDocs,
                canHideDocumentCreation: state.canHideDocumentCreation,
                canDeleteVehicleDocs: state.canDeleteVehicleDocs,
                canSignedOffHandoverSheet: state.canSignedOffHandoverSheet,
                myJobTxtColor: state.myJobTxtColor,
                myJobBgColor: state.myJobBgColor,
                canSignBrakeTests: state.canSignBrakeTests,
                canAccessSalesWIP: state.canAccessSalesWIP,
                canAccessDocumentReprocessScreen: state.canAccessDocumentReprocessScreen,

                canAmendJobNotes: state.canAmendJobNotes,
                autoLoadDocuments: state.autoLoadDocuments,
                eReportingAllowed: state.eReportingAllowed,
                eCommunicatorAllowed: state.eCommunicatorAllowed,
                eInvoiceAllowed: state.eInvoiceAllowed,
                isBudgetDashboard: false, //state.isBudgetDashboard,
                userCustomerGroupID: state.userCustomerGroupID,
                canAccessBudget: state.canAccessBudget,
                defaultInternalDashboard: state.defaultInternalDashboard,
                canSignOffTechWriteup: state.canSignOffTechWriteup,
                canDeleteTechWriteup: state.canDeleteTechWriteup,
                canAccessSalesPerformance: state.canAccessSalesPerformance,
                canAccessAppraisalPortal: state.canAccessAppraisalPortal,
                appraisalRoleID: state.appraisalRoleID,
                appraisalVehicleIDs: state.appraisalVehicle,
                maDashboardIDs: state.maDashboard,
                canAccessNominalMapping: state.canAccessNominalMapping,
                canAccessNominalTransactions: state.canAccessNominalTransactions,
                canAccessNominalAccounts: state.canAccessNominalAccounts,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            },
            technician: {
                ...commonData,
                branchIds: state.branches,
                customerIds: [],
                workflowIds: state.workflow,
                canOverrideMandatorySteps: state.canOverrideMandatorySteps,
                canAssignJobsToAuditor: false,
                canReturnJobsFromLastWorkflow: state.canReturnJobsFromLastWorkflow,
                canResetPassword: false,
                canAssignJobPriority: state.canAssignJobPriority,
                canSetCustomerRating: state.canSetCustomerRating,
                canAmendToDoList: state.canAmendToDoList,
                canAmendTechWriteUp: state.canAmendTechWriteUp,
                canAuthorisedHandoverSheet: state.canAuthorisedHandoverSheet,
                canActionedHandoverSheet: state.canActionedHandoverSheet,
                canAccessLockScreen: state.canAccessLockScreen,
                canUploadVehicleDocs: state.canUploadVehicleDocs,
                canHideDocumentCreation: state.canHideDocumentCreation,
                canDeleteVehicleDocs: state.canDeleteVehicleDocs,
                canSignedOffHandoverSheet: state.canSignedOffHandoverSheet,
                myJobTxtColor: state.myJobTxtColor,
                myJobBgColor: state.myJobBgColor,
                canSignBrakeTests: state.canSignBrakeTests,
                canAccessSalesWIP: state.canAccessSalesWIP,
                canAccessDocumentReprocessScreen: false,

                canAmendJobNotes: state.canAmendJobNotes,
                autoLoadDocuments: state.autoLoadDocuments,
                specialEquipmentAllowed: false,
                canAssignTechnician: state.canAssignTechnician,
                canDeleteDocuments: state.canDeleteDocuments,
                isAgedMeasure: state.isAgedMeasure,
                isDOC: state.isDOC,
                isKPIs: state.isKPIs,
                isParts: state.isParts,
                isSales: state.isSales,
                isService: state.isService,
                isWorkShop: state.isWorkShop,
                franchisesCode: state.franchises,
                eWIPAllowed: true,
                eReportingAllowed: state.eReportingAllowed,
                eCommunicatorAllowed: false,
                eInvoiceAllowed: false,
                isBudgetDashboard: false, //state.isBudgetDashboard,
                userCustomerGroupID: null,
                canAccessBudget: state.canAccessBudget,
                canAccessSalesPerformance: state.canAccessSalesPerformance,
                canSignOffTechWriteup: state.canSignOffTechWriteup,
                canDeleteTechWriteup: state.canDeleteTechWriteup,
                canAccessAppraisalPortal: state.canAccessAppraisalPortal,
                appraisalVehicleIDs: [],
                maDashboardIDs: state.maDashboard,
                canAccessNominalMapping: state.canAccessNominalMapping,
                canAccessNominalTransactions: state.canAccessNominalTransactions,
                canAccessNominalAccounts: state.canAccessNominalAccounts,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            },
            driver: {
                ...commonData,
                branchIds: [],
                branchIds: [],
                customerIds: [],
                workflowIds: [],
                canOverrideMandatorySteps: false, //state.canOverrideMandatorySteps,
                canAssignJobsToAuditor: false, //state.canAssignJobsToAuditor,
                canReturnJobsFromLastWorkflow: false, //state.canReturnJobsFromLastWorkflow,
                canResetPassword: false, //state.canResetPassword,
                canAssignJobPriority: false, //state.canAssignJobPriority,
                canAssignTechnician: false, //state.canAssignTechnician,
                canDeleteDocuments: false, //state.canDeleteDocuments,
                canSetCustomerRating: false, //state.canSetCustomerRating,
                isAgedMeasure: false, //state.isAgedMeasure,
                isDOC: false, //state.isDOC,
                isKPIs: false, //state.isKPIs,
                isParts: false, // state.isParts,
                isSales: true, //state.isSales,
                isService: false, //state.isService,
                isWorkShop: false, //state.isWorkShop,
                franchisesCode: [], //state.franchises,
                eWIPAllowed: true, //state.eWIPAllowed,
                specialEquipmentAllowed: false, //state.specialEquipmentAllowed,
                canAmendToDoList: false, //state.canAmendToDoList,
                canAmendTechWriteUp: false, //state.canAmendTechWriteUp,
                canAuthorisedHandoverSheet: false, //state.canAuthorisedHandoverSheet,
                canActionedHandoverSheet: false, //state.canActionedHandoverSheet,
                canAccessLockScreen: state.canAccessLockScreen,
                canUploadVehicleDocs: false, //state.canUploadVehicleDocs,
                canHideDocumentCreation: false, //state.canHideDocumentCreation,
                canDeleteVehicleDocs: false, //state.canDeleteVehicleDocs,
                canSignedOffHandoverSheet: false, //state.canSignedOffHandoverSheet,
                myJobTxtColor: '', //state.myJobTxtColor,
                myJobBgColor: '', //state.myJobBgColor,
                canSignBrakeTests: false, // state.canSignBrakeTests,
                canAccessSalesWIP: state.canAccessSalesWIP,
                canAccessDocumentReprocessScreen: false,

                canAmendJobNotes: false, //state.canAmendJobNotes,
                autoLoadDocuments: false, //state.autoLoadDocuments,
                eReportingAllowed: false, //state.eReportingAllowed,
                eCommunicatorAllowed: false, //state.eCommunicatorAllowed,
                eInvoiceAllowed: false, //state.eInvoiceAllowed,
                isBudgetDashboard: false, //false, //state.isBudgetDashboard,
                userCustomerGroupID: null, //state.userCustomerGroupID,
                canAccessBudget: false, //state.canAccessBudget,
                defaultInternalDashboard: null, //state.defaultInternalDashboard,
                canSignOffTechWriteup: false, //state.canSignOffTechWriteup,
                canDeleteTechWriteup: false, //state.canDeleteTechWriteup,
                canAccessSalesPerformance: false, //state.canAccessSalesPerformance,
                canAccessAppraisalPortal: false, //state.canAccessAppraisalPortal,
                appraisalRoleID: null, //state.appraisalRoleID,
                appraisalVehicleIDs: [], //state.appraisalVehicle,
                maDashboardIDs: [], //state.maDashboard,
                canAccessNominalMapping: false, //state.canAccessNominalMapping,
                canAccessNominalTransactions: false, //state.canAccessNominalTransactions,
                canAccessNominalAccounts: false, //state.canAccessNominalAccounts,
                canResetJobSignoffSignature: state.canResetJobSignoffSignature
            }
        };

        let data = {
            ...commonData,
            ...customData[`${state.userType}`],
            ...nicolReportDefaultFlag
        };
        let res = {};
        if (state.doc_id) {
            res = await UpdateUser(data);
        } else {
            let minLength = AppStorage.getPortalSettingPassLength();
            let pattern = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-@$!%*?&#])[A-Za-z\\d@$!%*?&#-]{${minLength},}$`, 'm');
            if (!pattern.test(state.password)) {
                showToast(`Password should be complex - ${minLength} minimum characters, at least one uppercase, at least one special character and one numeric value`);
                return;
            } else {
                data = { ...data, password: state.password, confirmPassword: state.confirm };
                res = await Adduser(data);
            }
        }
        if (!res.success) {
            console.error(res);
            showToast(
                <>
                    {Array.isArray(res.messages) ? (
                        res.messages.map((msg, i) => {
                            return <div key={i}>{msg}</div>;
                        })
                    ) : (
                        <div>{res.message}</div>
                    )}
                </>
            );
        } else {
            hideModal();
            props.onFormSubmit(true);
            showToast(res.message);
        }
    };

    const AutoBrChange = (event, value) => {
        const newBranchIds = value.map((c) => c.id);
        setSelectedData((st) => ({ ...st, branches: value }));
        
        setState((st) => {
            let prunedProcessIds = st.processes;
            
            if (processData.branchProcessMapping && processData.branchProcessMapping.length > 0) {
                if (newBranchIds.length === 0 && (st.userType === 'internal' || st.userType === 'technician')) {
                    prunedProcessIds = [];
                } else if (newBranchIds.length > 0) {
                    const allowedProcessIds = new Set(
                        processData.branchProcessMapping
                            .filter(m => newBranchIds.includes(m.branchId))
                            .map(m => m.processId)
                    );
                    prunedProcessIds = st.processes.filter(id => allowedProcessIds.has(id));
                }
            } else if (newBranchIds.length === 0 && (st.userType === 'internal' || st.userType === 'technician')) {
                prunedProcessIds = [];
            }
            
            let prunedWorkflowIds = st.workflow;
            if (prunedProcessIds.length > 0) {
                let allFilteredWorkflows = [];
                prunedProcessIds.forEach((m) => {
                    let tempArr = [...masterData.workflows].filter((k) => k.processID === m);
                    let filteredList = [];
                    if (st.userType === 'technician') {
                        filteredList = tempArr.filter((item) => item.technicianAllowed);
                    } else if (st.userType === 'internal') {
                        filteredList = tempArr.filter((item) => item.internalAllowed);
                    } else if (st.userType === 'auditor') {
                        filteredList = tempArr.filter((item) => item.auditorAllowed);
                    }
                    allFilteredWorkflows.push(...filteredList);
                });
                const allowedWorkflowIds = new Set(allFilteredWorkflows.map((w) => w.id));
                prunedWorkflowIds = st.workflow.filter(id => allowedWorkflowIds.has(id));
            } else {
                prunedWorkflowIds = [];
            }
            
            return { ...st, branches: newBranchIds, processes: prunedProcessIds, workflow: prunedWorkflowIds };
        });
    };

    const AutoPrChange = (event, value) => {
        const newProcessIds = value.map((c) => c.id);
        setSelectedData((st) => ({ ...st, processes: value }));
        
        setState((st) => {
            let prunedWorkflowIds = st.workflow;
            if (newProcessIds.length > 0) {
                let allFilteredWorkflows = [];
                newProcessIds.forEach((m) => {
                    let tempArr = [...masterData.workflows].filter((k) => k.processID === m);
                    let filteredList = [];
                    if (st.userType === 'technician') {
                        filteredList = tempArr.filter((item) => item.technicianAllowed);
                    } else if (st.userType === 'internal') {
                        filteredList = tempArr.filter((item) => item.internalAllowed);
                    } else if (st.userType === 'auditor') {
                        filteredList = tempArr.filter((item) => item.auditorAllowed);
                    }
                    allFilteredWorkflows.push(...filteredList);
                });
                const allowedWorkflowIds = new Set(allFilteredWorkflows.map((w) => w.id));
                prunedWorkflowIds = st.workflow.filter(id => allowedWorkflowIds.has(id));
            } else {
                prunedWorkflowIds = [];
            }
            return { ...st, processes: newProcessIds, workflow: prunedWorkflowIds };
        });
    };

    // const AutoModuleChange = (event, value) => {
    //     setSelectedData((st) => ({ ...st, modules: value }));
    //     setState((st) => {
    //         const nst = { ...st, modules: value.map((c) => c.id) };
    //         return nst;
    //     });
    // };

    const AutoFranchiseChange = (event, value) => {
        setSelectedData((st) => ({ ...st, franchises: value }));
        setState((st) => {
            const nst = { ...st, franchises: value.map((c) => c.id) };
            return nst;
        });
    };

    const AutoCustChange = (event, value) => {
        setSelectedData((st) => ({ ...st, customers: value }));
        setState((st) => {
            const nst = { ...st, customer: value.map((c) => c.id) };
            return nst;
        });
    };

    const AutoWorkChange = (event, value) => {
        setSelectedData((st) => ({ ...st, workflows: value }));
        setState((st) => {
            const nst = { ...st, workflow: value.map((c) => c.id) };
            return nst;
        });
    };

    const AutoAppraisalVehiclechange = (event, value) => {
        setSelectedData((st) => ({ ...st, appraisalVehicles: value }));
        setState((st) => {
            const nst = { ...st, appraisalVehicle: value.map((c) => c.id) };
            return nst;
        });
    };
    const AutoMaDashboardChange = (event, value) => {
        setSelectedData((st) => ({ ...st, maDashboard: value }));
        setState((st) => {
            const nst = { ...st, maDashboard: value.map((c) => c.id) };
            return nst;
        });
    };

    const fieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            const nst = { ...st, [name]: value };
            if (name == 'userType') {
                nst.branches = [];
                nst.workflow = [];
                nst.allworkflow = false;
            }
            if (!user) {
                nst.enableChange = nst.password && nst.email && nst.name && nst.password === nst.confirm;
            }
            return nst;
        });
    };
    useEffect(() => {
        if (state.processes.length > 0) {
            let allFilteredWorkflows = [];
            state.processes.forEach((m) => {
                let tempArr = [];
                let filteredList = [];
                tempArr = [...masterData.workflows].filter((k) => k.processID === m);
                if (state.userType === 'technician') {
                    filteredList = tempArr.filter((item) => item.technicianAllowed);
                } else if (state.userType === 'internal') {
                    filteredList = tempArr.filter((item) => item.internalAllowed);
                } else if (state.userType === 'auditor') {
                    filteredList = tempArr.filter((item) => item.auditorAllowed);
                }
                allFilteredWorkflows.push(...filteredList);
            });
            setMasterData((st) => ({ ...st, filteredWorkflows: allFilteredWorkflows }));
        } else {
            setMasterData((st) => ({ ...st, filteredWorkflows: [] }));
        }
    }, [state.processes, state.userType, masterData.workflows]);

    useEffect(() => {
        if (state.allworkflow) {
            setState(st => {
                const allIds = masterData.filteredWorkflows?.map((c) => c.id) || [];
                if (st.workflow.length !== allIds.length) {
                    return { ...st, workflow: allIds };
                }
                return st;
            });
            setSelectedData((mst) => ({
                ...mst,
                workflows: masterData.filteredWorkflows?.map((c) => ({ id: c.id, name: c.name })) || []
            }));
        }
    }, [masterData.filteredWorkflows, state.allworkflow]);

    useEffect(() => {
        if (state.allprocess) {
            const filteredProcesses = processData.processes ? processData.processes.filter(p => {
                if (!processData.branchProcessMapping || processData.branchProcessMapping.length === 0) return true;
                if (state.branches.length === 0 && (state.userType === 'internal' || state.userType === 'technician')) return false;
                if (state.branches.length === 0) return true;
                return processData.branchProcessMapping.some(m => state.branches.includes(m.branchId) && m.processId === p.id);
            }) : [];
            setState(st => {
                const allIds = filteredProcesses.map((c) => c.id);
                if (st.processes.length !== allIds.length) {
                    return { ...st, processes: allIds };
                }
                return st;
            });
        }
    }, [state.branches, processData.processes, processData.branchProcessMapping, state.allprocess, state.userType]);

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        if (checked) {
            setState((st) => {
                const nst = { ...st };
                nst[name] = checked;
                if (name == 'allbranch') {
                    nst.branches = [...brancheData.branches.map((c) => c.id)];
                } else if (name == 'allprocess') {
                    const filteredProcesses = processData.processes ? processData.processes.filter(p => {
                        if (!processData.branchProcessMapping || processData.branchProcessMapping.length === 0) return true;
                        if (nst.branches.length === 0 && (state.userType === 'internal' || state.userType === 'technician')) return false;
                        if (nst.branches.length === 0) return true;
                        return processData.branchProcessMapping.some(m => nst.branches.includes(m.branchId) && m.processId === p.id);
                    }) : [];
                    nst.processes = [...filteredProcesses.map((c) => c.id)];
                } else if (name == 'allcust') {
                    nst.customer = [...customerData.customers.map((c) => c.id)];
                } else if (name == 'allMaDashboard') {
                    nst.maDashboard = [...maDashboardData.maDashboard.map((c) => c.id)];
                } else if (name == 'allworkflow') {
                    nst.workflow = masterData.filteredWorkflows?.map((c) => c.id);
                } else {
                    nst[name] = checked;
                }
                return nst;
            });
            if (name == 'allworkflow') {
                setSelectedData((mst) => ({
                    ...mst,
                    workflows: masterData.filteredWorkflows?.map((c) => ({ id: c.id, name: c.name }))
                }));
            }
        } else {
            setState((st) => {
                const nst = { ...st, [name]: checked };
                return nst;
            });
        }
    };
    const handleColorChange = (fieldName) => (updatedColor) => {
        setState((prev) => ({
            ...prev,
            [fieldName]: updatedColor.hex
        }));
    };

    const handleClick = (name, value) => {
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };

    return (
        <Dialogs open={true} onClose={handleClose} maxWidth="md" fullScreen>
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    {props.copiedUser ? (
                        <DialogTitles>Add User</DialogTitles>
                    ) : user ? (
                        <DialogTitles>Update User</DialogTitles>
                    ) : (
                        <DialogTitles>Add User</DialogTitles>
                    )}
                </Box>
                <Box>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <DialogContents style={{ overflow: 'auto', height: '80vh' }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <TextBox autoFocus={true} required name="name" label="Name" onChange={fieldChange} value={state.name} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Phone Number" name="phone" variant="outlined" fullWidth onChange={fieldChange} value={state.phone} margin="dense" />
                    </Grid>
                    <Grid item xs={12}>
                        <TextBox required label="Email" name="email" type="email" onChange={fieldChange} value={state.email} />
                    </Grid>
                    {!user || props.copiedUser ? (
                        <>
                            <Grid item xs={12} sm={6}>
                                <PasswordBox autoComplete="new-password" label="Password" name="password" onChange={fieldChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <PasswordBox autoComplete="new-password" label="Confirm Password" name="confirm" onChange={fieldChange} />
                            </Grid>
                        </>
                    ) : null}
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={state.sendEmailFromOwnEmail} onChange={handleCheckbox} name="sendEmailFromOwnEmail" />}
                            label="Send Email From Own Email?"
                        />
                    </Grid>
                    <Grid item row xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">User Type</FormLabel>
                            <Grid item xs={12}>
                                <RadioGroup row aria-label="userType" name="userType" value={state.userType} onChange={fieldChange}>
                                    <FormControlLabel value="admin" control={<Radio />} label="Admin" />
                                    <FormControlLabel value="customer" control={<Radio />} label="Customer" />
                                    <FormControlLabel value="internal" control={<Radio />} label="Internal User" />
                                    {portalSettings.portalSettingeWIPEnabled && (
                                        <>
                                            <FormControlLabel value="auditor" control={<Radio />} label="Auditor" />
                                            <FormControlLabel value="technician" control={<Radio />} label="Technician" />
                                        </>
                                    )}
                                    <FormControlLabel value="driver" control={<Radio />} label="Driver" />
                                    {portalSettings.portalSettingeWIPSalesEnable && (
                                        <FormControlLabel value="driveragency" control={<Radio />} label="Driving Agency" />
                                    )}
                                </RadioGroup>
                            </Grid>
                        </FormControl>
                    </Grid>
                    {state.userType == 'technician' || state.userType == 'internal' ? (
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<PrimaryCheckbox onChange={handleCheckbox} checked={state.allbranch} name="allbranch" value={state.allbranch} />}
                                    label="All Branches"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {!state.allbranch ? (
                                    <Multiselect label="Branches" options={brancheData.branches} value={selectedData.branches} onChange={AutoBrChange} />
                                ) : null}
                            </Grid>
                        </Grid>
                    ) : null}
                    {state.userType != 'admin' ? (
                        <Grid item xs={12} sm={12}>
                            <Multiselect
                                label="Franchise Record"
                                options={franchiseData.franchises}
                                value={selectedData.franchises}
                                onChange={AutoFranchiseChange}
                            />
                        </Grid>
                    ) : null}

                    <Grid item xs={12}>
                        {state.userType == 'customer' ? (
                            <div>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<PrimaryCheckbox onChange={handleCheckbox} checked={state.allcust} name="allcust" value={state.allcust} />}
                                        label="All Customer"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    {!state.allcust ? (
                                        <MultiselectWithoutCheckbox
                                            label="Customer"
                                            options={customerData.customers}
                                            value={selectedData.customers}
                                            onChange={AutoCustChange}
                                        />
                                    ) : null}
                                </Grid>
                            </div>
                        ) : null}
                        {(state.userType == 'customer' || state.userType == 'internal' || state.userType == 'technician' || state.userType == 'auditor') && (
                            <Grid item xs={12}>
                                <Grid item xs={12} sm={6} md={6} lg={3} container>
                                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                                        <FormLabel shrink>Select Dashboard</FormLabel>
                                    </Grid>
                                    <SelectBox
                                        onChange={fieldChange}
                                        value={state.defaultInternalDashboard}
                                        name="defaultInternalDashboard"
                                        List={state.DashboardList || []}
                                    />
                                </Grid>
                                {/* <Multiselect label="Modules" options={moduleData.modules} value={selectedData.modules} onChange={AutoModuleChange} /> */}
                                <Grid container spacing={1} style={{ border: '1px solid #8080806e', marginTop: 8, padding: 3, marginBottom: 4 }}>
                                    <div>
                                        <UserModules
                                            franchiseData={franchiseData}
                                            AutoFranchiseChange={AutoFranchiseChange}
                                            selectedData={selectedData}
                                            handleClick={handleClick}
                                            state={state}
                                            handleCheckbox={handleCheckbox}
                                            handleColorChange={handleColorChange}
                                            portalSettings={portalSettings}
                                            masterData={masterData}
                                            AutoWorkChange={AutoWorkChange}
                                            fieldChange={fieldChange}
                                            custmerGroup={custmerGroup}
                                            process={selectedData.processes}
                                            AutoPrChange={AutoPrChange}
                                            processData={(() => {
                                                const filteredProcesses = processData.processes ? processData.processes.filter(p => {
                                                    if (!processData.branchProcessMapping || processData.branchProcessMapping.length === 0) return true;
                                                    if (state.branches.length === 0 && (state.userType === 'internal' || state.userType === 'technician')) return false;
                                                    if (state.branches.length === 0) return true;
                                                    return processData.branchProcessMapping.some(m => state.branches.includes(m.branchId) && m.processId === p.id);
                                                }) : [];
                                                return { ...processData, processes: filteredProcesses };
                                            })()}
                                            appraisalVehicle={selectedData.appraisalVehicles}
                                            AutoAppraisalVehiclechange={AutoAppraisalVehiclechange}
                                            appraisalVehicleOption={appraisalVehicleOption}
                                            maDashboardValue={selectedData.maDashboard}
                                            maDashboardOption={maDashboardData.maDashboard}
                                            AutoMaDashboardChange={AutoMaDashboardChange}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={<SecondaryCheckbox checked={state.isActive} onChange={handleCheckbox} name="isActive" />}
                            label="Is Active?"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={<SecondaryCheckbox checked={state.isLocked} onChange={handleCheckbox} name="isLocked" />}
                            label="Is Locked?"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={<SecondaryCheckbox checked={state.tempTwoFactorEnabled} onChange={handleCheckbox} name="tempTwoFactorEnabled" />}
                            label="Reset 2FA"
                        />
                    </Grid>
                </Grid>
            </DialogContents>
            <DialogsActions className="dialogActions">
                {!user ? (
                    <SecondaryButton className="Submitbtn" onClick={handleSubmit} disabled={!state.enableChange}>
                        Submit
                    </SecondaryButton>
                ) : (
                    <SecondaryButton className="Submitbtn" onClick={handleSubmit} disabled={!state.enableChange}>
                        {props.copiedUser ? 'Add' : 'Update'}
                    </SecondaryButton>
                )}
            </DialogsActions>
        </Dialogs>
    );
};

export default AddUserModal;
